import(/* webpackMode: "eager" */ "/home/interim/frontend/app/services/training-development/page.tsx");
